import React, {Component} from 'react';
import {injectIntl} from 'react-intl';

import FlatButton from 'material-ui/FlatButton'

import {Container} from 'flux/utils'
import AgrStore from './data/AgrStore'
import AgrActions from './data/AgrActions'

class BackToApp extends Component {

  static getStores() {
    return [AgrStore];
  }

  static calculateState(prevState) {
    var state = AgrStore.getState().toObject()

    var fromApp = false
    if (state.hash && state.hash.channel && state.hash.channel.indexOf("_app") !== -1) {
      fromApp = true
    }

    var result = {
      activeAgreement: state.activeAgreement,
      agreements: state.agreements,
      fromApp: fromApp
    }

    return result
  }

  getAgreementError = (agr) => {
    var errorMessage = null
    if (agr.status !== 'agree') {
      if (agr.status === 'blank') {
        errorMessage = "Plase make a choice"
      } else if (agr.status === 'reject' && (agr.mandatory === 'true' || agr.mandatory === true)) {
        errorMessage = "You need to agree to continue using deeper services"
      }
    }

    return errorMessage
  }

  render() {
    var backToApp = null
    if (this.state.fromApp && this.state.activeAgreement === null) {
      backToApp = <FlatButton
        style={{
          border: '1px solid white',
          color: 'white',
          margin: '20px',
          float: 'right',
          fontFamily: "Catamaran SemiBold"
        }}
        label={this.props.intl.formatMessage({id: "agreements.back"})}
        primary={true}
        onClick={AgrActions.backToApp}></FlatButton>

      this.state.agreements.forEach((agr) => {
        if (this.getAgreementError(agr) !== null) {
          backToApp = null
        }
      })

      if (this.state.agreements.length === 0) {
        // No agreements loaded, disable back button
        backToApp = null
      }
    }

    // Call android app to enable back functionality
    if (window.androidCallback && window.androidCallback.enableBackToApp) {
      // Android callback
      window.androidCallback.enableBackToApp(backToApp !== null)
    }

    return backToApp
  }
}

export default injectIntl(Container.create(BackToApp))


// WEBPACK FOOTER //
// ./src/BackToApp.js